module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AddToCart":{"button":"Přidat do košíku","variantRequired":"Prosím vyberte variantu","notAvailable":"Není skladem"}},"de":{"AddToCart":{"button":"In den Warenkorb","variantRequired":"Bitte wählen Sie eine Variante","notAvailable":"Nicht auf Lager"}},"sk":{"AddToCart":{"button":"Pridať do košíka","variantRequired":"Prosím vyberte variant","notAvailable":"Nie je na sklade"}}}')
  delete Component.options._Ctor
}
